import css from './ProcessingPlaceholder.module.scss';

type ProcessingPlaceholderProps = {
  onHoverChange?: (isHovered: boolean) => void;
  hasVideo?: boolean;
};

export const ProcessingPlaceholder = ({ onHoverChange, hasVideo }: ProcessingPlaceholderProps) => {
  return (
    <div
      className={css.container}
      onMouseEnter={() => onHoverChange?.(true)}
      onMouseLeave={() => onHoverChange?.(false)}
    >
      <div className={css.content}>
        <span className={css.title}>Processing</span>
        <span className={css.description}>
          {hasVideo
            ? 'Media preview is possible now. Currently working hard on processing the transcript and visual descriptions as soon as possible.'
            : 'Working hard on processing the media so you can enjoy it with the transcript and visual descriptions as soon as possible.'}
        </span>
      </div>
    </div>
  );
};
